import { render } from "./LearningHub.vue?vue&type=template&id=1da42616&scoped=true"
import script from "./LearningHub.vue?vue&type=script&lang=js"
export * from "./LearningHub.vue?vue&type=script&lang=js"

import "./LearningHub.vue?vue&type=style&index=0&id=1da42616&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da42616"]])

export default __exports__